import { MODIFICA_STATO_SPINNER } from './MODIFICA_STATO_SPINNER'
import { doc, updateDoc } from 'firebase/firestore'

export const RIFIUTA_RICHIESTA_PAGAMENTO = async (id) => {
    MODIFICA_STATO_SPINNER(true)
    await updateDoc(doc(db, 'richiesteAcquisti', id), { stato: 'rifiutato' })
    MODIFICA_STATO_SPINNER(false)
    return
}
